<template>
  <div>
    <nav class="a3d">
      <div class="nav-wrapper">
        <router-link :to="{name: 'Dash'}" ><img src="/static/img/siemens_logo_white.svg" class="a3d logo"></router-link>
        <ul id="nav-mobile" class="hide-on-med-and-down a3d bold" style="height: 100%;">
          <li><a @click="auth.logout()" class="menu-link">Logout</a></li>
        </ul>
      </div>
    </nav>
    <div class="center-align">
      <h4 class="onboard-title">Please finish configuring your account</h4>
    </div>
    <div class="form-wrapper">
      <div class="field-wrapper">
        <input type="checkbox" class="filled-in" id="isGovcloudUser" :checked="form.isGovcloudUser" v-model="form.isGovcloudUser"/>
        <label for="isGovcloudUser">My data needs to be kept in a government restricted zone due to it being covered by regulations such as ITAR.</label>
      </div>
    </div>
    <div class="center-align">
      <button class="a3d btn" @click="submit" :disabled="isLoading">Submit</button>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'onboard',
    data: function () {
      return {
        form: {
          isGovcloudUser: false
        },
        isLoading: false
      }
    },
    computed: {
      ...mapState([
        'user',
        'auth'
      ])
    },
    methods: {
      submit () {
        this.isLoading = true
        this.$store.dispatch('user/onboarding', {
          isGovcloudUser: this.form.isGovcloudUser
        })
          .finally(() => {
            this.resetFormData()
            this.isLoading = false
            this.$router.replace({name: 'Dash'})
            this.auth.login()
          })
      },
      resetFormData () {
        this.form.isGovcloudUser = false
      }
    }
  }
</script>

<style scoped>
  .onboard-title {
    padding-top: 20px;
  }
  .form-wrapper {
    padding: 40px 0 80px;
    max-width: 500px;
    margin: 0 auto;
  }
  .nav-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 64px;
    height: auto;
  }
  [type="checkbox"] + label {
    color: black;
    height: auto;
  }
  [type="checkbox"].filled-in + label:after, [type="checkbox"].filled-in + label:before {
    top: 15px;
  }

</style>



// WEBPACK FOOTER //
// Onboard.vue?30f14ead